export default __webpack_public_path__ + "static/media/CaravanseraiMap.a30b75d8.jpg";